import { styled } from "@mui/material/styles";
import { Box, Typography, Backdrop } from "@mui/material";
import { colors } from "../../../theme/theme";

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
}));

export const RootWrapper = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginLeft: "auto",
});

export const LogoWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  flexShrink: 1,
  minWidth: 0,
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const StyledLogo = styled("img")(({ theme }) => ({
  width: "100%",
  maxWidth: 500,
  height: "auto",
  objectFit: "contain",
  objectPosition: "center",
  [theme.breakpoints.down(1130)]: {
    maxWidth: 400,
  },
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 500,
  margin: "auto 0",
  [theme.breakpoints.down(1130)]: {
    margin: "0 auto",
    width: "100%",
    maxWidth: "500px",
  },
}));

export const ContentRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(4),
  width: "100%",
  [theme.breakpoints.down(1130)]: {
    flexDirection: "column",
  },
}));

export const ContentColumn = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  marginBottom: 16,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    justifyContent: "-moz-initial",
    alignItems: "-moz-initial",
  },
}));

export const VideoSection = styled(Box)(({ theme }) => ({
  marginTop: 24,
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
  cursor: "pointer",
  [theme.breakpoints.down(900)]: {
    width: "100%",
    maxWidth: "500px",
    margin: "24px auto auto",
  },
}));

export const VideoIframe = styled("iframe")(({ theme }) => ({
  border: "none",
  borderRadius: theme.spacing(2),
  width: "100%",
  aspectRatio: "16/9",
  display: "block",
}));

export const VideoLinkText = styled(Typography)({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 600,
  fontSize: "14px",
  color: colors.calmBlue,
  textDecoration: "underline",
  marginTop: "20px",
  textAlign: "end",
});

export const VideoLinkSpan = styled(Typography)({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "14px",
  color: colors.primary,
  textAlign: "center",
  textDecoration: "",
});

export const LessonBox = styled(Box)(({ theme }) => ({
  padding: 16,
  marginTop: 16,
  border: `1px solid ${theme.palette.text.primary}`,
  display: "flex",
  flexDirection: "column",
  maxWidth: 310,
  width: "100%",
  cursor: "pointer",
  [theme.breakpoints.down(1130)]: {
    margin: "auto",
    marginTop: 16,
  },
}));

export const LessonTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: theme.spacing(2),
  fontWeight: "500",
  color: theme.palette.text.primary,
  display: "inline-block",
  marginBottom: 8,
}));

export const LessonItemTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "18px",
  fontWeight: "bold",
  color: theme.palette.text.primary,
}));

export const IncomeBox = styled(Box)(({ theme }) => ({
  padding: 16,
  border: `1px solid ${theme.palette.text.primary}`,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: 310,
  width: "100%",
  [theme.breakpoints.down(1130)]: {
    margin: "auto",
  },
}));

export const IncomeText = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: theme.spacing(2),
  fontWeight: "500",
  color: theme.palette.text.primary,
  display: "inline-block",
}));

export const IncomeBoldSpan = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "18px",
  fontWeight: "bold",
  color: theme.palette.text.primary,
}));
